import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["tabIndex", "role", "aria-atomic", "data-mtype"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

export function render(_ctx, _cache) {
  const _component_Banner = _resolveComponent("Banner")
  const _component_Loader = _resolveComponent("Loader")
  const _component_LayoutCarousel = _resolveComponent("LayoutCarousel")
  const _component_Bubble = _resolveComponent("Bubble")
  const _component_Card = _resolveComponent("Card")
  const _component_Modal = _resolveComponent("Modal")
  const _component_QuickReply = _resolveComponent("QuickReply")
  const _component_MessageFeedback = _resolveComponent("MessageFeedback")
  const _component_TypingIndicator = _resolveComponent("TypingIndicator")
  const _component_ProcessingMessage = _resolveComponent("ProcessingMessage")
  const _component_LoginModal = _resolveComponent("LoginModal")
  const _component_ConsentModal = _resolveComponent("ConsentModal")
  const _component_TranscriptModal = _resolveComponent("TranscriptModal")
  const _component_FeedbackModal = _resolveComponent("FeedbackModal")

  return (_openBlock(), _createElementBlock("div", {
    id: "divChatBody",
    class: _normalizeClass(_ctx.getClass('chatBody')),
    ref: "chat_body"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('sr-only')),
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "true"
    }, _toDisplayString(_ctx.a11yAnnouncement), 3 /* TEXT, CLASS */),
    _createVNode(_Transition, {
      name: "satisfi_fade",
      persisted: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_Banner, null, null, 512 /* NEED_PATCH */), [
          [_vShow, _ctx.shouldShowBanner==true || _ctx.showWelcomeBanner==true]
        ])
      ]),
      _: 1 /* STABLE */
    }),
    (_ctx.isPageLoaded==false)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('chatContainerBgImage'))
    }, null, 2 /* CLASS */),
    _createElementVNode("main", {
      class: _normalizeClass(((_ctx.isMobileActive && _ctx.isMobileActive !== null) ? _ctx.getClass('messagesMobile') : '') + ' ' +
    _ctx.getClass('messages')),
      role: "main"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, msgIndex) => {
        return (_openBlock(), _createElementBlock("section", {
          ref_for: true,
          ref: "messageRefs",
          tabIndex: _ctx.enableMessageNavigation && message.type != 2 ? 0 : -1,
          role: _ctx.enableMessageNavigation && message.type != 2 ? 'region' : null,
          "aria-atomic": _ctx.enableMessageNavigation && message.type != 2 ? 'true' : null,
          class: _normalizeClass({
                    [_ctx.getClass('message')]: true,
                    [_ctx.getClass('bot')]:message.type==0 || message.type==3,
                    [_ctx.getClass('user')]:message.type==1,
                    [_ctx.getClass('timestamp')]:message.type==2
                }),
          "data-mtype": message.type,
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.onMessageLinkClick($event)))
        }, [
          _createCommentVNode(" SD-11140: Accessibility audit fix.\r\n                  - The bot image has an alt text needs to be hidden for screen reader users. "),
          (_ctx.isAvatarAltLabelRequired(message))
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                "aria-hidden": "true",
                class: _normalizeClass(_ctx.getClass('avatar-alt-label'))
              }, null, 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.getClass('visually-hidden')),
            textContent: _toDisplayString(_ctx.getMessagePrefix(message.type))
          }, null, 10 /* CLASS, PROPS */, _hoisted_2),
          (_ctx.shouldShowSenderDisplay(message))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.getClass('sender-display-container'))
              }, [
                (_ctx.shouldShowSenderAvatar(message))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.getSenderDisplayAvatarUrl(message),
                      alt: _ctx.getAvatarAltLabel(message.type),
                      class: _normalizeClass(_ctx.getClass('sender-display-avatar'))
                    }, null, 10 /* CLASS, PROPS */, _hoisted_3))
                  : _createCommentVNode("v-if", true),
                (_ctx.shouldShowSenderName(message))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(_ctx.getClass('sender-display-name')),
                      textContent: _toDisplayString(_ctx.getSenderDisplayName(message))
                    }, null, 10 /* CLASS, PROPS */, _hoisted_4))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.contents.structures, (structure, structureIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.isValidCarousel(message, structure) && structure.type!='modal')
                  ? (_openBlock(), _createBlock(_component_LayoutCarousel, {
                      key: 0,
                      components: structure.components,
                      type: structure.type,
                      settings: Array.isArray(structure.settings) ? {} : structure.settings,
                      layout: message.contents.layout
                    }, null, 8 /* PROPS */, ["components", "type", "settings", "layout"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (structure.type=='bubble' && _ctx.isShowChatBubble(structure))
                        ? (_openBlock(), _createBlock(_component_Bubble, {
                            key: 0,
                            components: structure.components,
                            structureSettings: structure && structure.settings || {},
                            class: _normalizeClass(structure.settings && structure.settings.forceMaxWidth ? _ctx.getClass('bubbleMaxWidth') : ''),
                            messageContentsettings: Array.isArray(message.contents.settings) ? {} : message.contents.settings,
                            inlineClickActions: structure && structure.inlineClickActions || {}
                          }, null, 8 /* PROPS */, ["components", "structureSettings", "class", "messageContentsettings", "inlineClickActions"]))
                        : _createCommentVNode("v-if", true),
                      (structure.type=='card')
                        ? (_openBlock(), _createBlock(_component_Card, {
                            key: 1,
                            components: structure.components,
                            structureSettings: structure && structure.settings || {},
                            class: _normalizeClass(structure.settings && structure.settings.forceMaxWidth ? _ctx.getClass('cardMaxWidth') : ''),
                            messageContentsettings: Array.isArray(message.contents.settings) ? {} : message.contents.settings,
                            inlineClickActions: structure && structure.inlineClickActions || {}
                          }, null, 8 /* PROPS */, ["components", "structureSettings", "class", "messageContentsettings", "inlineClickActions"]))
                        : _createCommentVNode("v-if", true),
                      (structure.type=='modal')
                        ? (_openBlock(), _createBlock(_component_Modal, {
                            key: 2,
                            components: structure.components,
                            messageSettings: structure.settings ? structure.settings : {},
                            messageContentsettings: Array.isArray(message.contents.settings) ? {} : message.contents.settings,
                            messageId: message.id
                          }, null, 8 /* PROPS */, ["components", "messageSettings", "messageContentsettings", "messageId"]))
                        : _createCommentVNode("v-if", true)
                    ])),
                (structure.type=='time')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("p", {
                        class: _normalizeClass(_ctx.getClass('time'))
                      }, _toDisplayString(structure.components[0].content), 3 /* TEXT, CLASS */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (structure.type=='fetch_msg')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass(_ctx.getClass('history'))
                    }, [
                      _createElementVNode("p", {
                        class: _normalizeClass(_ctx.getClass('time'))
                      }, _toDisplayString(structure.components[0].content), 3 /* TEXT, CLASS */)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          (_ctx.isArrayLengthGt0(message.contents.quickReplies))
            ? (_openBlock(), _createBlock(_component_QuickReply, {
                key: 2,
                msgIndex: msgIndex,
                messageContentsettings: Array.isArray(message.contents.settings) ? {} : message.contents.settings,
                data: message.contents.quickReplies
              }, null, 8 /* PROPS */, ["msgIndex", "messageContentsettings", "data"]))
            : _createCommentVNode("v-if", true),
          (_ctx.shouldShowFeedback(message))
            ? (_openBlock(), _createBlock(_component_MessageFeedback, {
                key: 3,
                messageId: message.id,
                extMsgId: message.contents.keys && message.contents.keys.extMsgId ? message.contents.keys.extMsgId : '',
                currentRating: _ctx.currentMessageRating(message),
                isInCooldown: _ctx.isFeedbackInCooldown(message.id),
                isRatingPending: _ctx.isRatingPending(message)
              }, null, 8 /* PROPS */, ["messageId", "extMsgId", "currentRating", "isInCooldown", "isRatingPending"]))
            : _createCommentVNode("v-if", true),
          (message.status==='failed')
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: _normalizeClass(_ctx.getClass('status'))
              }, [
                _createCommentVNode(" <p>Couldn't send message <a href=\"#\" @click=\"retryMessage(message.id)\">Retry</a> | <a href=\"#\"\r\n                            @click=\"cancelMessage(message.id)\">Cancel</a></p>"),
                _createElementVNode("p", null, _toDisplayString(_ctx.sendingIndicatorContent), 1 /* TEXT */)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_1))
      }), 256 /* UNKEYED_FRAGMENT */)),
      (_ctx.showTypingIndicator)
        ? (_openBlock(), _createBlock(_component_TypingIndicator, { key: 0 }))
        : _createCommentVNode("v-if", true),
      (!_ctx.showTypingIndicator && _ctx.showProcessingMessage)
        ? (_openBlock(), _createBlock(_component_ProcessingMessage, { key: 1 }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('anchor-scroll-spacer')),
        style: _normalizeStyle(_ctx.resetSpacer ? null : { minHeight: `calc(100dvh - ${_ctx.anchorScrollOffset}px)` }),
        "aria-hidden": "true"
      }, null, 6 /* CLASS, STYLE */)
    ], 2 /* CLASS */),
    (_ctx.showAdminLoginModal)
      ? (_openBlock(), _createBlock(_component_LoginModal, { key: 1 }))
      : _createCommentVNode("v-if", true),
    (_ctx.showConsentModal)
      ? (_openBlock(), _createBlock(_component_ConsentModal, { key: 2 }))
      : _createCommentVNode("v-if", true),
    (_ctx.showTranscriptModal)
      ? (_openBlock(), _createBlock(_component_TranscriptModal, { key: 3 }))
      : _createCommentVNode("v-if", true),
    (_ctx.showFeedbackModal)
      ? (_openBlock(), _createBlock(_component_FeedbackModal, {
          key: 4,
          messageData: _ctx.feedbackModalData
        }, null, 8 /* PROPS */, ["messageData"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}